import { useBlobUrl } from '@/hooks/use-blob-url';
import { authResource } from '@/resources/auth/auth.resource';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

export function UserAvatar({
  userId,
  name,
  email,
  avatarUpdatedAt,
  size,
  className,
}: {
  userId: string;
  name?: string;
  email: string;
  avatarUpdatedAt?: string;
  size?: 'default' | 'sm' | 'lg';
  className?: string;
}) {
  const label = name ?? email;
  const { url } = useBlobUrl(avatarUpdatedAt ? `${userId}:${avatarUpdatedAt}` : '', () =>
    authResource.avatar(userId),
  );

  return (
    <Avatar size={size} className={className}>
      {url && <AvatarImage src={url} alt={label} />}
      <AvatarFallback>{label.charAt(0).toUpperCase()}</AvatarFallback>
    </Avatar>
  );
}
